import router from '@/router'
const navigator = {
    back(step = -1) {
        router.go(step);
    },
    go(path, query = {}, params = {}) {
        const config = {};
        // 判断是路径还是路由名称
        if (path.startsWith('/')) {
            config.path = path;
        } else {
            config.name = path;
        }
        if (Object.keys(query).length) config.query = query;
        if (Object.keys(params).length) config.params = params;
        router.push(config).catch(err => {
            // 忽略重复跳转产生的 NavigationDuplicated 错误
            if (err.name !== 'NavigationDuplicated') {
                console.error(err);
            }
        });
    },
}

export default navigator